module.exports = __webpack_public_path__ + "img/sc.59dd3605.svg";